import { NodeResultAbstract } from '@/utils/measurements/node-results/node-result.abstract';
import { ValueItem } from '@/services/api.types';

type SingleResultValue = {
  value: string;
};

export class SingleResultClass extends NodeResultAbstract {
  getValue() {
    const found = this.getFirstValueChild<SingleResultValue>();
    return found?.value;
  }

  getValues(key?: string): number[] | string[] {
    const values = this.getAllValueChildren<SingleResultValue>();
    if (values) {
      return values.map(v => v.value);
    } else {
      return [];
    }
  }

  getMeasurementValues<SingleResultValue>(): Array<
    SingleResultValue & ValueItem
  > {
    const values = this.getAllValueChildren<SingleResultValue>();
    return values;
  }

  toString(): string {
    return this.getValue().toString();
  }
}
